import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";
import "../../css/Header.css";
import AdminIcon from "../../assets/Icons/AdminIcon.svg";
import HeaderHamburgerIcon from "../../assets/Icons/HeaderHamburgerIcon.svg";
import MobileHeaderAppanLogo from "../../assets/loginLogo.png";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import CustomAlert from "../../helpers/CustomAlert";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { logout } from "../store/authSlice";
import { ImProfile } from "react-icons/im";
import { LuLogOut } from "react-icons/lu";
import WalletBalanceModal from "./WalletBalanceModal";
import {isAccountCheckerRole, isAccountMakerRole, isOperationRole, isPartnerRole} from "../../utils";

function Header({ props, handleToggleSidebar }) {
  const loggedInUserName = sessionStorage.getItem("username");
  const [userName, setUserName] = useState("");
  const [loginTime, setLoginTime] = useState("");
  const balance = useSelector((state) => state.balance.balance);
  const { user, menu } = useSelector((state) => state.auth);
  const menuArray = menu ? menu.split("").map((char) => parseInt(char)) : [];
  const canAccessTopUpMainWallet = menuArray[49] === 1;
  const [showDropdown, setShowDropdown] = useState(false);
  const [showWalletBalance, setShowWalletBalance] = useState(false);
  const [walletDetail, setWalletDetails] = useState([]);
  const [walletTitle, setWalletTitle] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const storedName = sessionStorage.getItem("name");
    const storedLoginTime = sessionStorage.getItem("loginTime");

    if (storedName) {
      setUserName(storedName);
    }
    if (storedLoginTime) {
      setLoginTime(storedLoginTime); // Use the helper function
    }
  }, []);

  const location = useLocation();
  let title = "";

  switch (location.pathname) {
    case "/userMaster":
      title = "User Master";
      break;
    case "/CustomerOnboarding":
      title = "Company Onboarding";
      break;
    case "/retailerMaster":
      title = "Retailer Onboarding";
      break;
    case "/vendorMaster":
      title = "Vendor Onboarding";
      break;
    case "/sellsms":
      title = "Top-up SMS";
      break;
    case "/buysms":
      title = "Purchase Credits";
      break;
    case "/smstransaction":
      title = "Customer SMS Logs";
      break;
    case "/rcstransaction":
      title = "Customer RCS Logs";
      break;
    case "/menuManagement":
      title = "Menu Management";
      break;
    case "/settings":
      title = "Profile";
      break;
    case "/smsmaster":
      title = "System SMS Logs";
      break;
    case "/dlt":
      title = "DLT ";
      break;
    case "/roleMaster":
      title = "Role Master";
      break;
    case "/topUpRequest":
      title = "Top-up SMS Request";
      break;
    case "/vendortxnhistory":
      title = "Vendor History";
      break;
    case "/bulkMessage":
      title = "Bulk Message";
      break;
    case "/transactionReport":
      title = "Recharge";
      break;
    // case "/recharge":
    //   title = "Recharge";
    //   break;
    case "/walletActivity":
      title = "Top-Up SMS/RCS";
      break;
    case "/topUpMainWallet":
      title = "Main Wallet";
      break;
    case "/courierCompanyOnboarding":
      title = "Retailer (Courier)";
      break;
    case "/pickuporder":
      title = "Pickup Address";
      break;
    case "/orderMaster":
      title = "Order Master";
      break;
    case "/ledger":
      title = "Ledger";
      break;
    case "/rcsstandalonemsg":
      title = "RCS Standalone";
      break;
    case "/rcsplaintext":
      title = "RCS Plain Text";
      break;
    case "/rcscarousel":
      title = "RCS Carousel";
      break;
    case "/rcstemplates":
      title = "RCS Templates";
      break;
    case "/customerEnquiries":
      title = "Customer Enquiries";
      break;
    case "/whatsappConfig":
      title = "WhatsApp Config";
      break;
    case "/whatsappCampaign":
      title = "WhatsApp Campaign";
      break;
    case "/aiDashboard":
      title = "AI Dashboard";
      break;
    default:
      title = "Dashboard";
  }

  const handleLogout = () => {
    Swal.fire({
      title: "Do you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00b6ce",
      cancelButtonColor: "#e74c3c",
      confirmButtonText: "Yes, log me out!",
      cancelButtonText: "No",
      customClass: {
        confirmButton: "swal-confirm-button",
        cancelButton: "swal-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const requestBody = {
          username: loggedInUserName,
        };

        axiosPostApi(apiList.LOGOUT, requestBody)
          .then((response) => {
            if (response.status === 200) {
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("name");
              sessionStorage.removeItem("username");
              sessionStorage.removeItem("loginTime");
              dispatch(logout());
              navigate("/auth/login");
            } else {
              CustomAlert({
                title: "Failed to Logout",
                text:
                  response.data.message ||
                  "No data available for the specified criteria.",
                icon: "error",
                confirmButtonText: "Retry",
              }).then((result) => {
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  window.location.href = "/";
                }
              });
            }
          })
          .catch((error) => {
            CustomAlert({
              title: "Error",
              text: "An error occurred while logging out. Please try again later.",
              icon: "error",
              confirmButtonText: "Retry",
            }).then((result) => {
              if (result.isConfirmed) {
                sessionStorage.clear();
                window.location.href = "/";
              }
            });
          });
      }
    });
  };

  const handleOptionClick = (value) => {
    if (value === "profile") {
      navigate("/settings");
    } else if (value === "logout") {
      handleLogout();
    }
    setShowDropdown(false);
  };

  console.log("login", user);

  const handleClickOutside = (event) => {
    if (!event.target.closest(".user-profile")) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <header className="header-container">
      <div className="header-content">
        <div className="header-first-section">
          <div className="header-text">{title} </div>
          <div className="login-time-container">
            <span className="login-time">Last Logged In</span>
            <span className="login-time"> {user?.data?.lastLoginDate || sessionStorage.getItem("loginTime") || "N/A"}</span>
          </div>
        </div>
        <div className="header-icons">
          {
            isOperationRole() && canAccessTopUpMainWallet && <button
                type="button"
                className="view-balances-btn"
                style={{
                  padding: "0 16px",
                  borderRadius: "8px",
                  border: "none",
                  background: Number(balance?.unclearBalance || 0) > 0 ? "#ff9f43" : "var(--primary-color)",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "12px",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                  transition: "opacity 0.2s"
                }}
                onClick={() => {
                  if (isAccountMakerRole()) {
                    navigate("/topUpMainWallet?status=Pending");
                  } else if (isAccountCheckerRole()) {
                    navigate("/topUpMainWallet?status=In-progress");
                  } else {
                    navigate("/topUpMainWallet");
                  }
                }}
            >
              Pending Approvals:<br/><span style={{fontSize: "13px", fontWeight: "700"}}>₹ {balance?.unclearBalance
                  ? Number(balance.unclearBalance).toFixed(2).length > 9
                      ? Number(balance.unclearBalance).toFixed(2).slice(0, 9) + "..."
                      : Number(balance.unclearBalance).toFixed(2)
                  : "0.00"}</span>
            </button>
          }
          {
            isPartnerRole() && canAccessTopUpMainWallet && <button
                type="button"
                className="view-balances-btn"
                style={{
                  padding: "0 16px",
                  borderRadius: "8px",
                  border: "none",
                  background: Number(balance?.partnerCustomerUnclearBalance || 0) > 0 ? "#ff9f43" : "var(--primary-color)",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "12px",
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                  transition: "opacity 0.2s"
                }}
                onClick={() => {
                  navigate("/topUpMainWallet");
                }}
            >
              Pending Approvals:<br/><span style={{fontSize: "13px", fontWeight: "700"}}>₹ {balance?.partnerCustomerUnclearBalance
                  ? Number(balance.partnerCustomerUnclearBalance).toFixed(2).length > 9
                      ? Number(balance.partnerCustomerUnclearBalance).toFixed(2).slice(0, 9) + "..."
                      : Number(balance.partnerCustomerUnclearBalance).toFixed(2)
                  : "0.00"}</span>
            </button>
          }
          {
            !isOperationRole() && <button
                type="button"
                className="view-balances-btn"
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  background: "var(--primary-color)",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "13px",
                  cursor: "pointer",
                  marginRight: "16px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                  transition: "opacity 0.2s"
                }}
                onClick={() => {
                  setShowWalletBalance(true);
                  setWalletTitle("Wallet");
                  setWalletDetails(balance?.mainBalanceAmountList || []);
                }}
            >
              View Balance
            </button>
          }
          <div className="user-profile">
            <AiOutlineUser className="user-icon" />
            <div className="user-info">
              <span className="user-name">{userName || "User"}</span>
            </div>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => setShowDropdown((prev) => !prev)}
            >
              <img src={AdminIcon} alt="Admin Icon" />
            </span>
            {/* Custom Dropdown */}
            {showDropdown && (
              <div className="custom-dropdown">
                <div
                  className="dropdown-item"
                  onClick={() => handleOptionClick("profile")}
                >
                  <ImProfile style={{ marginRight: "8px" }} /> Profile
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => handleOptionClick("logout")}
                >
                  <LuLogOut style={{ marginRight: "8px" }} /> Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mobile-header">
        <div className="upper-section">
          <div className="hamburger-icon">
            <img
              className="hamburger-icon-image"
              src={HeaderHamburgerIcon}
              alt="Header Hamburger Icon"
              onClick={() => {
                // props.setIsLeftPanelVisible(true);
                handleToggleSidebar();
              }}
            />
          </div>
          <div className="mobile-header-appan-logo">
            <img
              className="appan-logo-image"
              src={MobileHeaderAppanLogo}
              alt="Mobile Header Appan Logo"
            />
          </div>
          <div className="user-profile">
            <AiOutlineUser className="user-icon" />
            <span>
              <img src={AdminIcon} alt="Admin Icon" />
            </span>
          </div>
        </div>
        <div className="lower-section">
          <div className="search-bar">
            <input
              type="text"
              className="lower-section-search-bar"
              placeholder="🔍︎ Search for anything..."
              aria-label="Search"
            />
          </div>
        </div>
      </div>

      <WalletBalanceModal
        show={showWalletBalance}
        handleClose={() => setShowWalletBalance(false)}
        walletDetail={walletDetail}
        walletTitle={walletTitle}
        balance={balance}
      />
    </header>
  );
}

export default Header;
